"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
// import {Attachment} from '../types';
const attachment_image_1 = __importDefault(require("../attachment-image"));
const attachment_video_1 = __importDefault(require("../attachment-video"));
/* interface AttachmentProps {
    value: Attachment;
} */
const AttachmentComponent = (props, ref) => {
    const { value } = props;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [value.type === 'image'
                && (0, jsx_runtime_1.jsx)(attachment_image_1.default, { ref: ref, url: value.url }), value.type === 'video'
                && (0, jsx_runtime_1.jsx)(attachment_video_1.default, { ref: ref, service: value.service, id: value.id, extraParams: value.extraParams })] }));
};
exports.default = (0, react_1.forwardRef)(AttachmentComponent);
